import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { setLoading } from "redux/actions/app.actions";
import { getServerErrorString } from "utils/common";
import queryString from "query-string";

export const getKitsInfo = (productId, kit, productName, isAddon) => {
  return (dispatch) => {
    // dispatch(setLoading(true));
    return request(
      `products/${productId}/PreferenceCard?kitNo=${kit}`,
      "get",
      null,
      true
    )
      .then((response) => {
        for (let product of response?.data?.inventoryProducts) {
          product.maxQuantity = product.quantity;
        }
        return {
          status: "success",
          data: response?.data ?? [],
        };
      })
      .catch((e, a) => {
        openNotificationWithIcon(
          "error",
          `${productName} ${isAddon ? "(Add-on)" : "(Service)"}`,
          `Preference card no found or some internal error has occured` ||
          e?.response?.Message ||
          e?.response?.data?.message ||
          "Network error has occured"
        );
      })
      .finally(() => {
        // dispatch(setLoading(false));
      });
  };
};

export const fetchLots = (kitNo, facilityProductId) => {
  return (dispatch) => {
    return request(
      `products/lots?kitNo=${kitNo}&facilityProductId=${facilityProductId}`,
      "get",
      null,
      true
    )
      .then((response) => {
        return {
          status: "success",
          data: response?.data ?? [],
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => { });
  };
};

export const disposeInventory = (
  orderid,
  kitNo,
  data
  // inventoryFacilityId,
  // inventoryId,
  // quantity
) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Orders/${orderid}/disposeInventory?kitNo=${kitNo}`,
      "patch",
      data,
      true
    )
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Inventory updated successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const getSubmittedInventory = (orderId) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Orders/${orderId}/DisposedInventories`, "get", null, true)
      .then((response) => {
        return {
          status: "success",
          data: response?.data ?? [],
        };
      })
      .catch((e, a) => {
        openNotificationWithIcon(
          "error",
          `Error`,
          e?.response?.Message ||
          e?.response?.data?.message ||
          "Network error has occured"
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};


export const getPreferenceCards = (productIds, kitNo) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    const params = queryString.stringify({
      productIds,
      kitNo
    }, {
      ignoreQueryPrefix: true
    })
    return request(
      `products/PreferenceCards?${params}`,
      "get",
      null,
      true
    )
      .then((response) => {
        // TODO: set maxQuantity to quantity
        // for (let product of response?.data?.inventoryProducts) {
        //   product.maxQuantity = product.quantity;
        // }
        return {
          status: "success",
          data: response?.data ?? [],
        };
      })
      .catch((e, a) => {
        openNotificationWithIcon(
          "error",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};